<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/css/base.css";
import Vue from "vue";
export default {
  name: "App",
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    // this.ismob();
  },
  methods: {
    ismob() {
      function isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      }
      if (isMobile()) {
        if (this.$route.path.indexOf("mb") != -1) {
          this.$router.push({ path: "/index_mb" });
        }
      } else {
        if (this.$route.path.indexOf("mb") != -1) {
          this.$router.push({ path: "/" });
        }
      }
    },
  },
};
</script>

<style lang='less'>
@import "./assets/less/base.less";
@co: #f39518!important;
#app {
  width: 100%;
  height: 100%;
}
.el-menu--horizontal {
  .el-menu {
    background-color: rgba(0, 0, 0, 0.5) !important;
    padding: 15px 0;
    .el-menu-item {
      background-color: rgba(0, 0, 0, 0) !important ;
    }
  }
}
.el-submenu.is-active .el-submenu__title {
  color: @co!important;
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: @co;
  border-bottom: none !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  color: @co;
}
* {
  box-sizing: border-box;
}
.jus {
  text-align: justify;
  text-justify: distribute-all-lines;
  text-justify: inter-ideograph;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
}

.el-menu--horizontal {
  margin-left: -1%;
  width: 9%;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 100%;
  li {
    height: 40px !important;
    line-height: 40px !important;
    padding: 1% 0 !important;
  }
}

/*菜单关闭*/
.el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  // -webkit-transform: rotateZ(-90deg);
  // -ms-transform: rotate(-90deg);
  // transform: rotateZ(-90deg);
  display: none;
}

// 企业文化
.company_culture {
  * {
    color: #1d2429 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue